import { mapLanguageToProps } from 'i18n'
import ar from 'careers/i18n/ar'
import da from 'careers/i18n/da'
import en from 'careers/i18n/en'
import fi from 'careers/i18n/fi'
import no from 'careers/i18n/no'
import se from 'careers/i18n/se'
import de from 'careers/i18n/de'
import it from 'careers/i18n/it'
import es from 'careers/i18n/es'
import nl from 'careers/i18n/nl'
import fr from 'careers/i18n/fr'
import pl from 'careers/i18n/pl'
import el from 'careers/i18n/el'
import ro from 'careers/i18n/ro'
import bg from 'careers/i18n/bg'
import hu from 'careers/i18n/hu'
import uk from 'careers/i18n/uk'
import cs from 'careers/i18n/cs'
import hr from 'careers/i18n/hr'
import sk from 'careers/i18n/sk'
import sl from 'careers/i18n/sl'
import sr from 'careers/i18n/sr'
import ru from 'careers/i18n/ru'
import et from 'careers/i18n/et'
import zh from 'careers/i18n/zh'
import pt from 'careers/i18n/pt'
import ja from 'careers/i18n/ja'
import tr from 'careers/i18n/tr'
import ko from 'careers/i18n/ko'
import zhTW from 'careers/i18n/zh-tw'

export const languages = { ar, da, de, en, fi, no, se, it, es, nl, fr, pl, el, ro, bg, hu, uk, cs, hr, sk, sl, sr, ru, et, zh, pt, ja, tr, ko, 'zh-tw': zhTW }

export function mapLanguageToComponentProps(map) {
  return mapLanguageToProps(languages, 'component', map)
}

export function mapLanguageToPageProps(map) {
  return mapLanguageToProps(languages, 'page', map)
}
